import { useEffect, useRef, useState, useCallback } from "react";

export default function useMousePosition() {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handler = (e) => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handler, { passive: true });
    return () => window.removeEventListener("mousemove", handler);
  }, []);

  return pos;
}

export function useMagnetic(ref, maxMove = 6) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;

    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 140) {
          const tx = Math.max(-maxMove, Math.min(maxMove, dx * 0.12));
          const ty = Math.max(-maxMove, Math.min(maxMove, dy * 0.12));
          el.style.transform = `translate(${tx}px, ${ty}px)`;
        } else {
          el.style.transform = "translate(0, 0)";
        }
      });
    };

    const onLeave = () => {
      el.style.transform = "translate(0, 0)";
    };

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
      cancelAnimationFrame(raf);
    };
  }, [ref, maxMove]);
}

export function useCardTilt(ref, maxTilt = 8) {
  const [shine, setShine] = useState({ x: 50, y: 50, visible: false });

  const handleMove = useCallback(
    (e) => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      const rotateY = (x - 0.5) * maxTilt * 2;
      const rotateX = (0.5 - y) * maxTilt * 2;
      el.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
      setShine({ x: x * 100, y: y * 100, visible: true });
    },
    [ref, maxTilt]
  );

  const handleLeave = useCallback(() => {
    const el = ref.current;
    if (el) el.style.transform = "";
    setShine({ x: 50, y: 50, visible: false });
  }, [ref]);

  return { shine, handleMove, handleLeave };
}
